import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RuralWomenEmpowerment from './pages/RuralWomenEmpowerment';
import MentalHealthAwareness from './pages/MentalHealthAwareness';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/rural-women-empowerment" element={<RuralWomenEmpowerment />} />
          <Route path="/mental-health-awareness" element={<MentalHealthAwareness />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 